import { render, staticRenderFns } from "./openid-modify.vue?vue&type=template&id=6c7b9b16"
import script from "./openid-modify.vue?vue&type=script&lang=js"
export * from "./openid-modify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports